// extracted by mini-css-extract-plugin
export default {"selected":"Recruiter_selected__fYkQe"};